import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=2ec788b7&scoped=true&"
import script from "./agreement.component.ts?vue&type=script&lang=ts&"
export * from "./agreement.component.ts?vue&type=script&lang=ts&"
import style0 from "./agreement.vue?vue&type=style&index=0&id=2ec788b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec788b7",
  null
  
)

export default component.exports